<template>
    <div
            v-bind:class="'type-' + type"
            class="message-box">
        {{ message }}
    </div>
</template>

<script>
    export default {
        props: {
            message: String,
            type: String
        }
    }
</script>

<style scoped lang="scss">
    .message-box {
        text-align: center;
        padding: 10px;
        &.type-error {
            background: red;
            color: white;
        }
        &.type-info {
            background: #d9e4ed;
            color: #474747;
        }
    }
</style>